import { render, staticRenderFns } from "./base.vue?vue&type=template&id=5dbfb7ad"
import script from "./base.js?vue&type=script&lang=js&external"
export * from "./base.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports